import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { closeModal } from "../../../actions/modal_actions";
import BundleGroupFormModal from "./bundle_group_form_modal";

const msp = () => ({});

const mdp = (dispatch) => ({
  closeModal: () => {
    dispatch(closeModal())
  },
});

export default withRouter(connect(msp, mdp)(BundleGroupFormModal));